/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * List of all services provided to the patient under a given contact which is linked by this sub-contact to other structuring elements.
 */
export class ServiceLink {
  constructor(json: JSON | any) {
    Object.assign(this as ServiceLink, json)
  }

  serviceId?: string
}
